import { checkIfDayOff } from "~/utils/gantt";

export const getIsDateWorkday = (workDays, dayOffs, date) => {
  let isWorkday = true;

  if (workDays.indexOf(date.day()) === -1) {
    return false;
  }

  if (Array.isArray(dayOffs)) {
    dayOffs.forEach((dayOff) => {
      if (checkIfDayOff(dayOff, date)) {
        isWorkday = false;
      }
    });
  }

  return isWorkday;
};
